import { render } from "./PatientForm.vue?vue&type=template&id=4db2c764&scoped=true"
import script from "./PatientForm.vue?vue&type=script&lang=ts"
export * from "./PatientForm.vue?vue&type=script&lang=ts"

import "./PatientForm.vue?vue&type=style&index=0&id=4db2c764&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4db2c764"

export default script